import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import ChatWidget from '../../components/Chat/ChatWidget';

const Chat = () => {
  return (
    <Container maxWidth={false} disableGutters sx={{ height: 'calc(100vh - 64px)' }}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
        <Typography variant="h4" gutterBottom>
          SMS Conversations
        </Typography>
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <ChatWidget />
        </Box>
      </Box>
    </Container>
  );
};

export default Chat;
